import React from 'react';
import { ThingToDoLink, ThingToDoModal } from '.';
import { ThingToDoClean } from './ThingToDoClean';
import { ThingToDoSidebar } from './ThingToDoSidebar';

export interface ThingToDoTour {
  readonly id: string;
  readonly title: string;
  readonly description?: string;
  readonly url: string;
  readonly image?: { readonly id: string; readonly url: string };
  readonly rating?: { readonly avgRating: number; readonly reviewsCount: number };
  readonly price?: { readonly valueInMinorUnits: number; readonly currencyCode: string };
}
export interface ThingToDoComponentProps {
  readonly id: string;
  readonly sortOrder: number;
  readonly title: string;
  readonly category?: string;
  readonly description: string;
  readonly image?: { readonly id: string; readonly url: string };
  readonly url?: string;
  readonly tours?: ReadonlyArray<ThingToDoTour>;
  readonly designType?: 'fullRow' | 'widget';
  readonly forceFullWidth?: boolean;
  readonly layoutType?: 'sidebar' | 'modal' | 'clean' | 'links' | '';
  readonly location?: string;
}

export const ThingToDoComponent = (props: ThingToDoComponentProps) => {
  switch (props.layoutType) {
    case 'clean':
      return <ThingToDoClean {...props} />;
    case 'sidebar':
      return <ThingToDoSidebar {...props} />;
    case 'modal':
      return <ThingToDoModal {...props} />;
    case 'links':
      return <ThingToDoLink {...props} />;
    default:
      return <ThingToDoSidebar {...props} />;
  }
};
